import { Deserializable } from '../protocols/deserializable';
import { AccountType } from './account-type';
import { AccountTypeIdEnum } from '../enum/shared/account-type-id.enum';
import { MemberAccountStatusIdEnum } from './enum/member-account-status-id.enum';
import { MemberAccountStatus } from './member-account-status';

export class AccountDetails implements Deserializable {
  public accountId!: number;
  public typeId!: AccountTypeIdEnum;
  public type!: AccountType;
  public employerId!: number;
  public employer!: string;
  public status!: MemberAccountStatus;
  public statusId!: MemberAccountStatusIdEnum;
  public totalBalance!: number;

  onDeserialize() {
    if (!!this.type) {
      this.type = window.injector.Deserialize.instanceOf(AccountType, this.type);
    }
  }
}
